import { useTranslation } from 'react-i18next';

import { useAppContext } from '../../AppContextProvider';
import { AdyenConfig } from '../Adyen.types';

import styles from './AdyenApplePayButton.module.scss';
import { APPLE_PAY_CONTAINER_ID } from './AdyenApplePayButton.static';
import useAdyenApplePay from './hooks/useAdyenApplePay';

import '@adyen/adyen-web/dist/adyen.css';

export type AdyenApplePayButtonRef = {
  getApplePayAuthorizationData: () => unknown;
};

export interface AdyenApplePayButtonProps extends AdyenConfig {
  countryCode: string;
  currency: string;
  amount: number;
  paymentMethodsResponse: unknown;
  onSubmit: (applePayToken: string) => void;
  onFatalError: (error: unknown) => void;
}

const AdyenApplePayButton: React.FC<AdyenApplePayButtonProps> = ({
  adyenEnvironment,
  clientKey,
  countryCode,
  currency,
  amount,
  paymentMethodsResponse,
  onSubmit,
  onFatalError,
}) => {
  const { t } = useTranslation();
  const { locale } = useAppContext();

  useAdyenApplePay({
    adyenEnvironment,
    clientKey,
    locale,
    t,
    countryCode,
    currency,
    amount,
    paymentMethodsResponse,
    onSubmit,
    onFatalError,
  });

  return (
    <div
      id={APPLE_PAY_CONTAINER_ID}
      className={styles.applePayContainer}
      data-zta="adyen-apple-pay-button"></div>
  );
};

export default AdyenApplePayButton;
